// reducers/CountriesAndStates.js
import { createSlice } from '@reduxjs/toolkit'

const CountriesAndStates = createSlice({
  name: 'location',
  initialState: {
    countries: [],
    states: []
  },
  reducers: {
    setCountries(state, action) {
      state.countries = action.payload
    },
    setStates(state, action) {
      state.states = action.payload
    },
    clearLocationData(state) {
      state.countries = []
      state.states = []
    }
  }
})

export default CountriesAndStates.reducer
export const { setCountries, setStates, clearLocationData } = CountriesAndStates.actions
